// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__x6gqF","inner":"Footer_inner__3NVBy","nextIcon":"Footer_nextIcon__1v7FS","innerLeft":"Footer_innerLeft__2oHnR"};